import $ from 'jquery'

// Expose the jQuery to the window here so that bootstrap can register its plugins to jQuery
// jQuery and bootstrap import must be in different files becuase assign statement below is run after the import statement
window.$ = $
window.jQuery = $

// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Dropdown controller
document.addEventListener('turbo:load', function() {
    document.querySelectorAll('[data-controller="dropdown"]').forEach(dropdown => {
        const button = dropdown.querySelector('[data-action*="dropdown#toggle"]');
        const menu = dropdown.querySelector('[data-dropdown-target="menu"]');

        button.addEventListener('click', (e) => {
            e.stopPropagation();
            menu.classList.toggle('hidden');
        });

        document.addEventListener('click', (e) => {
            if (!dropdown.contains(e.target)) {
                menu.classList.add('hidden');
            }
        });
    });

    // Auto-dismiss for alerts
    document.querySelectorAll('[data-controller="auto-dismiss"]').forEach(alert => {
        setTimeout(() => {
            alert.style.opacity = '0';
            alert.style.transform = 'translateY(-10px)';
            setTimeout(() => alert.remove(), 300);
        }, 5000);
    });
});

// Toast functions
function showToast(message, type = 'success') {
    const toast = document.getElementById('toast');
    const toastMessage = document.getElementById('toast-message');
    const toastIcon = toast.querySelector('i');

    toastMessage.textContent = message;

    if (type === 'success') {
        toastIcon.className = 'fas fa-check-circle text-green-400';
    } else if (type === 'error') {
        toastIcon.className = 'fas fa-exclamation-circle text-red-400';
    }

    toast.classList.remove('translate-y-20', 'opacity-0');

    setTimeout(() => {
        toast.classList.add('translate-y-20', 'opacity-0');
    }, 3000);
}

window.copyLink = function(btn, url) {
    navigator.clipboard.writeText(url).then(() => {
        const originalHTML = btn.innerHTML;
        btn.innerHTML = '<i class="fas fa-check text-[10px]"></i>';
        btn.classList.add('bg-green-600');
        btn.classList.remove('bg-blue-600');

        showToast('链接已复制到剪贴板');

        setTimeout(() => {
            btn.innerHTML = originalHTML;
            btn.classList.remove('bg-green-600');
            btn.classList.add('bg-blue-600');
        }, 2000);
    }).catch(err => {
        showToast('复制失败', 'error');
        console.error('Failed to copy:', err);
    });
}

window.copyToClipboard = function(text) {
    navigator.clipboard.writeText(text).then(() => {
        showToast('链接已复制到剪贴板！');
    }).catch(err => {
        showToast('复制失败', 'error');
        console.error('Failed to copy:', err);
    });
}

// Close modals on Escape key
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        document.querySelectorAll('.fixed.inset-0:not(.hidden)').forEach(modal => {
            modal.classList.add('hidden');
        });
    }
});

// Global clipboard and notification functions
// window.copyToClipboard = function(text, buttonElement = null) {
//   navigator.clipboard.writeText(text).then(function() {
//     showToast('链接已复制到剪贴板', 'success');
//   }, function(err) {
//     console.error('Could not copy text: ', err);
//     showToast('复制失败，请手动复制', 'danger');
//   });
// };

window.copyAllLinks = function(buttonElement = null) {
  const links = Array.from(document.querySelectorAll('.interview-url')).map(input => input.value);
  const allLinksText = links.join('\n');

  navigator.clipboard.writeText(allLinksText).then(function() {
    showToast(`已复制 ${links.length} 个调研链接到剪贴板`, 'success');

    // Show "Copied" popover on the button if provided
    if (buttonElement || event.target) {
      const button = buttonElement || event.target;
      showCopiedPopover(button);
    }
  }, function(err) {
    console.error('Could not copy text: ', err);
    showToast('复制失败，请手动复制', 'danger');
  });
};

window.copyAllInterviewSetLinks = function(buttonElement = null) {
  const links = Array.from(document.querySelectorAll('.interview-set-url')).map(input => input.value);
  const allLinksText = links.join('\n');

  navigator.clipboard.writeText(allLinksText).then(function() {
    showToast(`已复制 ${links.length} 个调研链接到剪贴板`, 'success');

    // Show "Copied" popover on the button if provided
    if (buttonElement || event.target) {
      const button = buttonElement || event.target;
      showCopiedPopover(button);
    }
  }, function(err) {
    console.error('Could not copy text: ', err);
    showToast('复制失败，请手动复制', 'danger');
  });
};

window.showToast = function(message, type = 'success') {
  const toast = document.getElementById('toast');
  const toastMessage = document.getElementById('toast-message');
  const toastIcon = toast.querySelector('i');

  toastMessage.textContent = message;

  if (type === 'success') {
    toastIcon.className = 'fas fa-check-circle text-green-400';
  } else if (type === 'error' || type === 'danger') {
    toastIcon.className = 'fas fa-exclamation-circle text-red-400';
  } else if (type === 'warning') {
    toastIcon.className = 'fas fa-exclamation-triangle text-amber-400';
  } else {
    toastIcon.className = 'fas fa-info-circle text-blue-400';
  }

  toast.classList.remove('translate-y-20', 'opacity-0');

  setTimeout(() => {
    toast.classList.add('translate-y-20', 'opacity-0');
  }, 3000);
};

window.showCopiedPopover = function(button) {
  const originalText = button.innerHTML;
  button.innerHTML = '<i class="fas fa-check"></i> 已复制';
  button.classList.add('bg-green-600', 'text-white', 'border-green-600');
  button.classList.remove('bg-white', 'text-slate-600', 'border-slate-200');

  setTimeout(function() {
    button.innerHTML = originalText;
    button.classList.remove('bg-green-600', 'text-white', 'border-green-600');
    button.classList.add('bg-white', 'text-slate-600', 'border-slate-200');
  }, 2000);
};

// For backward compatibility
window.showNotification = function(message, type) {
  // Convert Bulma type to Tailwind type
  let toastType;
  switch(type) {
    case 'is-success': toastType = 'success'; break;
    case 'is-danger': toastType = 'danger'; break;
    case 'is-warning': toastType = 'warning'; break;
    case 'is-info': toastType = 'info'; break;
    default: toastType = 'success'; break;
  }

  showToast(message, toastType);
};
